export default [
  {
    path: "/allianceList", // 联盟专区列表页
    name: "allianceList",
    component: () =>
      import(
        /* webpackChunkName: "alliance" */ "../views/AllianceZone/AllianceList.vue"
      ),
    meta: {
      eventId: "W-XH-31-V1",
      eventName: "协会列表曝光",
      module: "协会服务",
    },
  },
  {
    path: "/allianceDetail", // 联盟详情
    name: "allianceDetail",
    component: () =>
      import(
        /* webpackChunkName: "alliance" */ "../views/AllianceZone/AllianceDetail/index.vue"
      ),
    meta: {
      eventId: "W-XH-32-V1",
      eventName: "协会详情曝光",
      module: "协会服务",
    },
  },
  {
    path: "/allianceActDetail", // 联盟活动详情
    name: "allianceActDetail",
    component: () =>
      import(
        /* webpackChunkName: "alliance" */ "../views/AllianceZone/AllianceActDetail/index.vue"
      ),
    meta: {
      eventId: "W-XH-33-V1",
      eventName: "协会活动详情曝光",
      module: "协会服务",
    },
  },
  {
    path: "/joinAlliance", // 加入联盟
    name: "joinAlliance",
    component: () =>
      import(
        /* webpackChunkName: "alliance" */ "../views/AllianceZone/JoinAlliance/index.vue"
      ),
    meta: {
      eventId: "W-XH-34-V1",
      eventName: "加入协会曝光",
      module: "协会服务",
    },
  },
];
